<template>
<div class="chapter">
<div class="inner_page">
<p class="C153"><a id="page_xii">Common cause:</a></p><a id="page_xii">
<p class="C152">1. lack of significance in individual high or low values, and</p>
<p class="C152">2. an objective shared with another person or a group.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Common_C.vue?9cf0e626